import { render, staticRenderFns } from "./prices-approval.vue?vue&type=template&id=7a0fee56&"
import script from "./prices-approval.vue?vue&type=script&lang=js&"
export * from "./prices-approval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports